import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Link } from "react-router-dom";
import UploadFiles from "../upload/uploadFiles";
import IConnectionActions, * as connectionActions from "../../../../redux/actions/connectionActions";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import { IProject, IUser, IAuthenticationState, IConnection, IApplicationState } from "../../../../models/applicationState";
import HeaderComponent from "../header/header";
import Select from "react-select";
import avatar from "../../../../assets/images/avatar.png";

export interface IProfileComponentProps extends RouteComponentProps, React.Props<ProfileComponent> {
    project: IProject;
    loggedInUser: IAuthenticationState;
    path: object;
    connections: IConnection;
    actions: IConnectionActions;
    appSecurityTokenAction: IApplicationActions;
    projectActions: IProjectActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        loggedInUser: state.loggedInUser,
    };
}

export interface IProfileComponentState { 
    userData: IUser;
    userRole: any;
    adminRoles: any;
    profileEdit: boolean;
}

@connect(mapStateToProps)

export default class ProfileComponent
    extends React.Component<IProfileComponentProps, IProfileComponentState> {
        public state: IProfileComponentState = {
            userData: this.props.loggedInUser.user,
            userRole: null,
            profileEdit: false,
            adminRoles: [
                { value: 'ROLE_USER', label: 'USER' },
                { value: 'ROLE_ADMIN', label: 'ADMIN' },
                { value: 'ROLE_SUPPORT_ADMIN', label: 'SUPPORT_ADMIN' }
            ],
        }

    public componentDidMount() {
        this.setAdminRole();
    }
    public render() {

        const { userData } = this.state;

        return (
            <>
                <HeaderComponent
                history={this.props.history}
                match={this.props.match}
                location={this.props.location} />



                <div className="container">
                    <div className="row mt-5  justify-content-center">



                        <div className="col-md-10" id="profile">

                            <div className="card pl-3 pr-3 edit-profile">

                                <div className="pt-3">
                                   
                                    <h5 className="float-left">Profile</h5>


                                    <Link to="/change-password" role="button" className="float-right btn-custom " title="Change Password" >Change Password</Link>

                                    <button role="button" onClick={this.editProfile} className="float-right btn-edit" title="Edit Profile"><i className="fa fa-edit" aria-hidden="true"></i></button>
                                    
                                    

                                </div>

                             
                                <hr  />
                                  
                                


                                <div className="row">

                                    <div className={this.state.profileEdit ? "col-md-9" : "col-md-9 read-only pointer-events"}>

                                        <div className="row">

                                            <div className="col-md-6">
                                                <label >First Name </label>
                                                <input value={userData.name} type="text" className="form-control" name="first name" placeholder="John" ></input>
                                            </div>

                                            <div className="col-md-6">
                                                <label >Last Name </label>
                                                <input type="text" value={userData.given_name} className="form-control" name="last name" placeholder="Doe"></input>
                                            </div>

                                            <div className="col-md-6">
                                                <label >Email </label>
                                                <input value={userData.emails[0]} type="text" className="form-control" name="username"></input>
                                            </div>

                                            <div className="col-md-6 hidden">
                                                <label >Contact No </label>
                                                <input type="text" className="form-control" name="username"></input>
                                            </div>
                                            <div className="col-md-6">
                                                <label >Role </label>
                                                <Select options={this.state.adminRoles}
                                                    value={this.state.userRole}
                                                    placeholder="Select"
                                                    className="react-select-container zindex-20"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#161a1f",
                                                            primary: "#6b727d",
                                                            neutral0: "#222830",
                                                            neutral20: "#44474c",
                                                            neutral30: "#272c33",
                                                            neutral50: "#fff",
                                                            neutral80: "#9da7b5",
                                                        },
                                                    })}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">

                                        <div className={this.state.profileEdit ? "text-center" : "text-center read-only pointer-events"}>
                                            <img src={avatar ? avatar : ""} className="avatar img-thumbnail z-2" alt="avatar" />
                                            <div className="text-center">Upload photo...</div>
                                            <input type="file" accept="image/*, application/pdf" id="before-select" className="upload-docs d-block z-5" />

                                        </div>



                                    </div>



                                </div>


                               {this.state.profileEdit &&
                                <div className="row mt-5 mb-3 justify-content-center">

                                    <div className="col-md-12 text-center" >
                                        <button  onClick={this.editProfile} className="btn mr-2" role="button">  Cancel </button >

                                        <button className="btn" role="button">  Update </button >
                                    </div>


                                </div>}
                                {!this.state.profileEdit &&
                                <div className="row mt-5 mb-3 justify-content-center">

                                    <div className="col-md-12 text-center" >
                                        <button  onClick={this.backToRoute} className="btn mr-2" role="button">  Cancel </button >
                                    </div>


                                </div>}


                        <span className="small text-info">Please click on Edit Icon to update Profile.</span>

                            </div>


                        </div>
                    </div>

                </div>
            </>
        );
    }

    private setAdminRole = () => {
        const userDataRole = this.state.userData.extension_role;
        const userRole = this.state.adminRoles.find((role) => role.label === userDataRole);
        this.setState({ userRole });

    }

    private editProfile = () => {
        const { profileEdit } = this.state;
        this.setState({ profileEdit: !profileEdit });
    }

    private backToRoute = () => {
        this.props.history.goBack();
    }
}
